module.exports = __webpack_public_path__ + "img/beichen.e8976617.jpg";